import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AumicoCoreProvider } from '../provider/aumico.core.provider';
import { RoutesUtil } from '../utils/routes.util';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationsService {
    constructor(
        private readonly http: HttpClient,
        private readonly coreProvider: AumicoCoreProvider,
        private readonly routesUtil: RoutesUtil,
    ) {}

    getSupportedLocales$(): Observable<string[]> {
        const url = this.routesUtil.getSupportedLocales();
        this.coreProvider.dispatchBlockingRequest('getSupportedLocales$');
        return this.http
            .get<string[]>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('getSupportedLocales$')));
    }
}
